import { Navigate, Outlet, useLocation } from "react-router-dom";

import { Loading } from "@/components/UI";
import { ROUTES } from "@/constants";
import type { RootState } from "@/store";
import { useAppSelector } from "@/store/hooks";

type PersistState = RootState & {
  _persist?: {
    rehydrated?: boolean;
  };
};

export const AuthRoute = () => {
  const location = useLocation();
  const { accessToken, isAuthenticated, status, user } = useAppSelector(
    (state) => state.auth,
  );
  const isRehydrated = useAppSelector(
    (state) => (state as PersistState)._persist?.rehydrated ?? true,
  );

  if (
    !isRehydrated ||
    (Boolean(accessToken) &&
      !user &&
      (status === "idle" || status === "loading"))
  ) {
    return <Loading fullScreen tip="Đang khôi phục phiên đăng nhập..." />;
  }

  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate replace state={{ from }} to={ROUTES.LOGIN} />;
  }

  return <Outlet />;
};
